var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mp-spinner",class:{ overlay: _vm.withOverlay }},[(_vm.longWaitText)?_c('MPNotification',{staticClass:"full full-with-navbar",attrs:{"type":"offer","title":_vm.longWaitText}}):_vm._e(),_c('div',{staticClass:"loader",class:`loader--${_vm.color} loader--${_vm.size}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }